import type { Asset, AssetReservation, ExternalServiceItem, ExternalServiceItemStatus } from "../types/imobi";

const ITEM_STATUSES_CONSIDERED_OUT: ExternalServiceItemStatus[] = ["em_uso", "confirmado_com_responsavel", "retorno_pendente"];

export function periodsOverlap(startA: string, endA: string | undefined, startB: string, endB: string | undefined): boolean {
  const startATime = new Date(startA).getTime();
  const startBTime = new Date(startB).getTime();
  const endATime = endA ? new Date(endA).getTime() : Number.POSITIVE_INFINITY;
  const endBTime = endB ? new Date(endB).getTime() : Number.POSITIVE_INFINITY;

  if (Number.isNaN(startATime) || Number.isNaN(startBTime)) {
    return false;
  }

  return startATime <= endBTime && startBTime <= endATime;
}

export function findConflictingReservation(
  reservations: AssetReservation[],
  plannedStartAt: string,
  expectedReturnAt: string | undefined,
  excludeServiceId?: string
): AssetReservation | undefined {
  return reservations
    .filter((reservation) => reservation.status === "reservado" || reservation.status === "em_uso")
    .filter((reservation) => reservation.serviceId !== excludeServiceId)
    .find((reservation) => periodsOverlap(plannedStartAt, expectedReturnAt, reservation.plannedStartAt, reservation.expectedReturnAt));
}

export function isAssetReturnOverdue(asset: Pick<Asset, "externalServiceStatus" | "currentExternalServiceExpectedReturnAt">): boolean {
  if (!asset.currentExternalServiceExpectedReturnAt) {
    return false;
  }

  if (asset.externalServiceStatus !== "em_servico" && asset.externalServiceStatus !== "em_retorno") {
    return false;
  }

  return new Date(asset.currentExternalServiceExpectedReturnAt).getTime() < Date.now();
}

export function isItemReturnOverdue(item: Pick<ExternalServiceItem, "status" | "expectedReturnAt">): boolean {
  if (!item.expectedReturnAt) {
    return false;
  }

  if (!ITEM_STATUSES_CONSIDERED_OUT.includes(item.status)) {
    return false;
  }

  return new Date(item.expectedReturnAt).getTime() < Date.now();
}
